var _rect, _path, _path2, _path3, _path4, _circle, _path5, _path6, _rect2, _circle2, _path7, _path8, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadBill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 29.5H39",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 35.5H39",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 41.5H39",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 23.5H33",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.8947,
    cy: 23.3947,
    r: 1.89474,
    fill: "#0E5CF4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51 20.5L51.0679 19.7531C51.2881 19.7731 51.4882 19.8892 51.6148 20.0705C51.7415 20.2517 51.7816 20.4796 51.7247 20.6932L51 20.5ZM47.5054 45.8281L48.2545 45.7914L48.2931 46.5808L47.5028 46.5781L47.5054 45.8281ZM50.9321 21.2469L42.964 20.5225L43.0998 19.0286L51.0679 19.7531L50.9321 21.2469ZM43.1719 45.0629L47.508 45.0781L47.5028 46.5781L43.1666 46.5628L43.1719 45.0629ZM46.7563 45.8647C46.5838 42.3386 47.057 32.3756 50.2753 20.3068L51.7247 20.6932C48.543 32.6244 48.0901 42.4322 48.2545 45.7914L46.7563 45.8647Z",
    fill: "#0E5CF4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9681 19.7755L15 20.5C18.2 32.5 18.6631 42.3854 18.4946 45.8281L22.8308 45.8128",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 17.5,
    width: 20,
    height: 30,
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 47.5,
    r: 8,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8008 47.5L43.4579 47.5L45.2865 47.5L46.2008 47.5",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43 44.2992L43 47.9564L43 49.7849L43 50.6992",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    stroke: "#0E5CF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBill);
export default __webpack_public_path__ + "static/media/upload-bill.dd7e1c9e99315e5be5d0703a18ddcd1b.svg";
export { ForwardRef as ReactComponent };